import { makeThemedClassReference } from './utils';
export var resolveClassName = function resolveClassName(themeRef, classRef) {
  return classRef[0] === '$' ? makeThemedClassReference(themeRef, classRef.substring(1)) : classRef;
};